import brakes from '~/assets/icons/brakes.svg';
import engine from '~/assets/icons/engine_2.svg';
import exhaust from '~/assets/icons/exhaust.svg';
import radiator from '~/assets/icons/radiator.svg';
import settings from '~/assets/icons/settings.svg';
import starter from '~/assets/icons/starter.svg';
import suspension from '~/assets/icons/suspension.svg';
import tires from '~/assets/icons/tires_2.svg';
import turbo from '~/assets/icons/turbo.svg';
import { TechTuningCategory } from '~/shared';
import brakesImage from '../../assets/images/items/brakes.png';
import engineImage from '../../assets/images/items/engine.png';
import exhaustImage from '../../assets/images/items/exhaust.png';
import radiatorImage from '../../assets/images/items/radiator.png';
import starterImage from '../../assets/images/items/starter.png';
import suspensionImage from '../../assets/images/items/suspension.png';
import tiresImage from '../../assets/images/items/tires.png';
import turboImage from '../../assets/images/items/turbo.png';

export const CategoryNames = {
	[TechTuningCategory.SETTINGS]: 'Настройки транспорта',
	[TechTuningCategory.ENGINE]: 'Двигатель',
	[TechTuningCategory.TURBO]: 'Турбонаддув',
	[TechTuningCategory.EXHAUST]: 'Выхлопная система',
	[TechTuningCategory.RADIATOR]: 'Система охлаждения',
	[TechTuningCategory.STARTER]: 'Система зажигания',
	[TechTuningCategory.BRAKES]: 'Тормозная система',
	[TechTuningCategory.SUSPENSION]: 'Подвеска',
	[TechTuningCategory.TIRES]: 'Шины',
};

export const CategoryNamesSell = {
	[TechTuningCategory.SETTINGS]: '',
	[TechTuningCategory.ENGINE]: 'двигатель',
	[TechTuningCategory.TURBO]: 'турбонаддув',
	[TechTuningCategory.EXHAUST]: 'выхлопную систему',
	[TechTuningCategory.RADIATOR]: 'систему охлаждения',
	[TechTuningCategory.STARTER]: 'систему зажигания',
	[TechTuningCategory.BRAKES]: 'тормозную систему',
	[TechTuningCategory.SUSPENSION]: 'подвеску',
	[TechTuningCategory.TIRES]: 'шины',
};

export const CategoryImages = {
	[TechTuningCategory.SETTINGS]: settings,
	[TechTuningCategory.ENGINE]: engine,
	[TechTuningCategory.TURBO]: turbo,
	[TechTuningCategory.EXHAUST]: exhaust,
	[TechTuningCategory.RADIATOR]: radiator,
	[TechTuningCategory.STARTER]: starter,
	[TechTuningCategory.BRAKES]: brakes,
	[TechTuningCategory.SUSPENSION]: suspension,
	[TechTuningCategory.TIRES]: tires,
};

export const CategoryItemImages: Partial<Record<TechTuningCategory, string>> = {
	[TechTuningCategory.ENGINE]: engineImage,
	[TechTuningCategory.TURBO]: turboImage,
	[TechTuningCategory.EXHAUST]: exhaustImage,
	[TechTuningCategory.RADIATOR]: radiatorImage,
	[TechTuningCategory.STARTER]: starterImage,
	[TechTuningCategory.BRAKES]: brakesImage,
	[TechTuningCategory.SUSPENSION]: suspensionImage,
	[TechTuningCategory.TIRES]: tiresImage,
};

export const categories = [
	{
		id: 0,
		type: TechTuningCategory.SETTINGS,
		name: CategoryNames[TechTuningCategory.SETTINGS],
		image: CategoryImages[TechTuningCategory.SETTINGS],
	},
	{
		id: 1,
		type: TechTuningCategory.ENGINE,
		name: CategoryNames[TechTuningCategory.ENGINE],
		image: CategoryImages[TechTuningCategory.ENGINE],
	},
	{
		id: 2,
		type: TechTuningCategory.TURBO,
		name: CategoryNames[TechTuningCategory.TURBO],
		image: CategoryImages[TechTuningCategory.TURBO],
	},
	{
		id: 3,
		type: TechTuningCategory.EXHAUST,
		name: CategoryNames[TechTuningCategory.EXHAUST],
		image: CategoryImages[TechTuningCategory.EXHAUST],
	},
	{
		id: 4,
		type: TechTuningCategory.RADIATOR,
		name: CategoryNames[TechTuningCategory.RADIATOR],
		image: CategoryImages[TechTuningCategory.RADIATOR],
	},
	{
		id: 5,
		type: TechTuningCategory.STARTER,
		name: CategoryNames[TechTuningCategory.STARTER],
		image: CategoryImages[TechTuningCategory.STARTER],
	},
	{
		id: 6,
		type: TechTuningCategory.BRAKES,
		name: CategoryNames[TechTuningCategory.BRAKES],
		image: CategoryImages[TechTuningCategory.BRAKES],
	},
	{
		id: 7,
		type: TechTuningCategory.SUSPENSION,
		name: CategoryNames[TechTuningCategory.SUSPENSION],
		image: CategoryImages[TechTuningCategory.SUSPENSION],
	},
	{
		id: 8,
		type: TechTuningCategory.TIRES,
		name: CategoryNames[TechTuningCategory.TIRES],
		image: CategoryImages[TechTuningCategory.TIRES],
	},
];

export const getCategoryByType = (type: TechTuningCategory | null) => {
	return categories.find((category) => category.type === type);
};
